var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",on:{"click":_vm.toggle}},[_vm._t("default",function(){return [_vm._v("How It Works")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }